import React, { useEffect, useState } from "react";
import { MenuHeader } from "./MenuHeader";
import { MenuItem } from "./MenuItem";

import { User } from "../../app/user/userSlice";
import { useSelector } from "react-redux";
import ordersImg from "../../images/icons/orders-icon.svg";
import uploadOrderImg from "../../images/icons/upload-order-icon.svg";
import fileWithErrorImg from "../../images/icons/file-with-error-icon.svg";
import uploadFileStatus from "../../images/icons/CloudUpload.svg";

let menutiems = [
  {
    text: "Órdenes",
    url: "/orders",
    icon: ordersImg,
    id: "6",
    check: false,
  },
  {
    text: "Subir Órdenes",
    url: "/upload/order",
    icon: uploadOrderImg,
    id: "7",
    check: false,
  },
  {
    text: "Archivos en Error",
    url: "/files/error",
    icon: fileWithErrorImg,
    id: "8",
    check: false,
  },
  {
    text: "Actualización de Estado",
    url: "/upload/status/order",
    icon: uploadFileStatus,
    id: "9",
    check: false,
  },
];

export const Menu = ({ openMenu, handelOpenMenu }) => {
  const user = useSelector(User);
  const [optionsMenu, setOptionsMenu] = useState(null);
  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));

  const { username } = getEmail;

  useEffect(() => {
    const getPermisos = menutiems?.map((permisoMenu) => {
      let findPermisos = user?.permisosMenu?.find(
        (permiso) => permisoMenu.id === permiso.idPermiso
      ) ;
      if (findPermisos != null || menutiems.id !== "6" || menutiems.id !== "7" || menutiems.id !== "8"| menutiems.id !== "9") {
        permisoMenu.check = true;
      }
      return permisoMenu;
    });
    setOptionsMenu(getPermisos);
  }, [user?.permisosMenu]);

  useEffect(() => {
  }, [username]);

  return (
    <div className="menu">
      <MenuHeader openMenu={openMenu} handelOpenMenu={handelOpenMenu} />
      <div className="menu__list">
        {optionsMenu?.map((menuitem, index) => (
          <MenuItem
            key={index}
            check={menuitem.check}
            menuitem={menuitem}
            openMenu={openMenu}
          />
        ))}
      </div>
    </div>
  );
};
